<!-- KML Upload Modal Backdrop - Blocks background clicks -->
<div class="kml-upload-backdrop" *ngIf="visible" (click)="onHideDialog()"></div>

<!-- KML Upload Modal - Matches Document Upload Wizard Pattern -->
<div class="kml-upload-wrapper" *ngIf="visible" (click)="$event.stopPropagation()">
    <!-- Modal Container -->
    <div class="kml-upload-modal">
        <!-- Modal Header -->
        <div class="kml-modal-header">
            <h3>KML File Management</h3>
            <button type="button" class="close-btn" (click)="onHideDialog()">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Tab Navigation -->
        <div class="kml-modal-tabs">
            <button class="tab-button" [class.active]="activeTab === 'upload'" (click)="switchTab('upload')">
                <i class="fas fa-upload"></i>
                Upload File
            </button>
            <button class="tab-button" [class.active]="activeTab === 'manage'" (click)="switchTab('manage')">
                <i class="fas fa-folder-open"></i>
                Manage Files
            </button>
        </div>

        <!-- Modal Body -->
        <div class="kml-upload-body">
            <!-- Upload Tab -->
            <div class="tab-panel" [hidden]="activeTab !== 'upload'">
                <!-- Hidden File Input -->
                <input #fileInput type="file" style="display: none;" accept=".kml,.kmz,.png"
                    (change)="onFileSelected($event)" />

                <!-- KML Type Dropdown (Conditional for Sales/Inventory) -->
                <div class="form-group form-group-inline" *ngIf="showKmlTypeInput">
                    <label class="form-label">KML Type <span class="required">*</span></label>
                    <select class="form-control" [(ngModel)]="kmlType" [disabled]="isLoading">
                        <option value="">-- Select KML Type --</option>
                        <option *ngFor="let option of kmlTypeOptions" [value]="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                </div>

                <!-- Layout Version Dropdown (shown if versions exist) -->
                <div class="form-group form-group-inline" *ngIf="hasLayoutVersions">
                    <label class="form-label">Layout Version</label>
                    <select class="form-control" [(ngModel)]="selectedVersion" (change)="onVersionChange()"
                        [disabled]="isLoading">
                        <option value="">-- Select Version --</option>
                        <option *ngFor="let version of layoutVersionsOptions" [value]="version.value">
                            {{ version.label }}
                        </option>
                    </select>
                </div>

                <!-- Version Name Input (shown if no versions or "Add New Version" selected) -->
                <div class="form-group form-group-inline" *ngIf="showVersionInput">
                    <label class="form-label">Version Name</label>
                    <input type="text" class="form-control" [(ngModel)]="versionName" placeholder="e.g., Version 1.0"
                        [disabled]="isLoading" />
                </div>

                <!-- File Upload Box with Drag & Drop -->
                <div class="upload-box-dark" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)" [class.drag-over]="isDragOver">
                    <i class="fas fa-cloud-upload-alt fa-3x"></i>
                    <p>Drag and drop KML file here</p>
                    <p class="upload-divider">or</p>
                    <label class="file-input-label" (click)="triggerFileInput()">
                        <span>Click to browse files</span>
                    </label>
                    <p class="file-hint">.kml, .kmz, .png files supported</p>
                </div>

                <!-- Selected File Display -->
                <div class="upload-file-display-dark" *ngIf="selectedFile">
                    <i class="fas fa-check-circle"></i>
                    <span>{{ selectedFile.name }}</span>
                    <button type="button" class="remove-file-btn" (click)="resetForm()" [disabled]="isLoading">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <!-- Manage Tab -->
            <div class="tab-panel" [hidden]="activeTab !== 'manage'">
                <!-- Loading State -->
                <div *ngIf="isLoadingFilesList" class="loading-state">
                    <i class="fas fa-spinner fa-spin"></i>
                    <p>Loading files...</p>
                </div>

                <!-- KML Files List Table (using CommonTableDarkComponent) -->
                <app-common-table-dark *ngIf="!isLoadingFilesList" [columnDefs]="kmlFilesColumnDefs"
                    [data]="kmlFilesList" [showSearchBar]="false" (rowAction)="onKmlFileTableAction($event)">
                </app-common-table-dark>

                <!-- No Files Message -->
                <div *ngIf="!isLoadingFilesList && (!kmlFilesList || kmlFilesList.length === 0)"
                    class="no-files-message">
                    <i class="fas fa-inbox"></i>
                    <p>No KML files uploaded yet</p>
                </div>
            </div>
        </div>

        <!-- Modal Footer / Actions -->
        <div class="kml-modal-footer">
            <!-- Upload Tab Footer -->
            <ng-container *ngIf="activeTab === 'upload'">
                <button type="button" class="btn btn-secondary" (click)="onHideDialog()" [disabled]="isLoading">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" (click)="submitUpload()"
                    [disabled]="!selectedFile || (showKmlTypeInput && !kmlType) || isLoading">
                    <i class="fas fa-upload" *ngIf="!isLoading"></i>
                    <i class="fas fa-spinner fa-spin" *ngIf="isLoading"></i>
                    {{ isLoading ? 'Uploading...' : 'Upload' }}
                </button>
            </ng-container>

            <!-- Manage Tab Footer -->
            <ng-container *ngIf="activeTab === 'manage'">
                <button type="button" class="btn btn-secondary" (click)="loadKmlFilesList()">
                    <i class="fas fa-sync-alt"></i>
                    Refresh
                </button>
                <button type="button" class="btn btn-secondary" (click)="onHideDialog()">
                    Close
                </button>
            </ng-container>
        </div>
    </div>
</div>